/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M5.28988 10C5.10128 10.6337 5 11.305 5 12C5 15.866 8.13401 19 12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5C10.0413 5 8.27052 5.80447 7 7.10102L8 4M10.5 14.5H13.5V12H10.5V9.5H13.5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<rect
				x="2"
				y="2"
				width="20"
				height="20"
				rx="5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<rect
				opacity="0.12"
				x="2"
				y="2"
				width="20"
				height="20"
				rx="5"
				fill="currentColor"
			/>
			<path
				d="M5.28988 10C5.10128 10.6337 5 11.305 5 12C5 15.866 8.13401 19 12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5C10.0413 5 8.27052 5.80447 7 7.10102L8 4M10.5 14.5H13.5V12H10.5V9.5H13.5M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3.98005 1.79497C5.04961 1.25 6.44974 1.25 9.25 1.25H14.75C17.5503 1.25 18.9504 1.25 20.02 1.79497C20.9608 2.27433 21.7257 3.03924 22.205 3.98005C22.75 5.04961 22.75 6.44974 22.75 9.25V14.75C22.75 17.5503 22.75 18.9504 22.205 20.02C21.7257 20.9608 20.9608 21.7257 20.02 22.205C18.9504 22.75 17.5503 22.75 14.75 22.75H9.25C6.44974 22.75 5.04961 22.75 3.98005 22.205C3.03924 21.7257 2.27433 20.9608 1.79497 20.02C1.25 18.9504 1.25 17.5503 1.25 14.75V9.25C1.25 6.44974 1.25 5.04961 1.79497 3.98005C2.27433 3.03924 3.03924 2.27433 3.98005 1.79497ZM8.7138 4.23018C8.84093 3.83596 8.62441 3.41332 8.23018 3.2862C7.83596 3.15907 7.41332 3.37559 7.2862 3.76982L6.2862 6.87083C6.17943 7.20192 6.31435 7.56297 6.61208 7.74291C6.90982 7.92284 7.2922 7.87441 7.53568 7.62594C8.67094 6.46742 10.251 5.75 12 5.75C15.4518 5.75 18.25 8.54822 18.25 12C18.25 15.4518 15.4518 18.25 12 18.25C8.54822 18.25 5.75 15.4518 5.75 12C5.75 11.3782 5.84056 10.779 6.00872 10.2139C6.12687 9.81693 5.90082 9.39931 5.50382 9.28116C5.10681 9.16301 4.68919 9.38906 4.57104 9.78606C4.36199 10.4885 4.25 11.2318 4.25 12C4.25 16.2802 7.71979 19.75 12 19.75C16.2802 19.75 19.75 16.2802 19.75 12C19.75 7.71979 16.2802 4.25 12 4.25C10.7113 4.25 9.4957 4.56488 8.42638 5.1215L8.7138 4.23018ZM10.5 8.75C10.0858 8.75 9.75 9.08579 9.75 9.5V12C9.75 12.4142 10.0858 12.75 10.5 12.75H12.75V13.75H10.5C10.0858 13.75 9.75 14.0858 9.75 14.5C9.75 14.9142 10.0858 15.25 10.5 15.25H13.5C13.9142 15.25 14.25 14.9142 14.25 14.5V12C14.25 11.5858 13.9142 11.25 13.5 11.25H11.25V10.25H13.5C13.9142 10.25 14.25 9.91421 14.25 9.5C14.25 9.08579 13.9142 8.75 13.5 8.75H10.5Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M22 9.5V9V9C22 7.13872 22 6.20808 21.7553 5.45492C21.2607 3.93273 20.0673 2.73931 18.5451 2.24472C17.7919 2 16.8613 2 15 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22H15C16.8613 22 17.7919 22 18.5451 21.7553C20.0673 21.2607 21.2607 20.0673 21.7553 18.5451C22 17.7919 22 16.8613 22 15V15V14.5M5.28988 10C5.10128 10.6337 5 11.305 5 12C5 15.866 8.13401 19 12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5C10.0413 5 8.27052 5.80447 7 7.10102L8 4M10.5 14.5H13.5V12H10.5V9.5H13.5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M5.28988 10C5.10128 10.6337 5 11.305 5 12C5 15.866 8.13401 19 12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5C10.0413 5 8.27052 5.80447 7 7.10102L8 4M10.5 14.5H13.5V12H10.5V9.5H13.5M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M9.25 1.25C6.44974 1.25 5.04961 1.25 3.98005 1.79497C3.03924 2.27433 2.27433 3.03924 1.79497 3.98005C1.25 5.04961 1.25 6.44974 1.25 9.25V14.75C1.25 17.5503 1.25 18.9504 1.79497 20.02C2.27433 20.9608 3.03924 21.7257 3.98005 22.205C5.04961 22.75 6.44974 22.75 9.25 22.75H14.75C17.5503 22.75 18.9504 22.75 20.02 22.205C20.9608 21.7257 21.7257 20.9608 22.205 20.02C22.75 18.9504 22.75 17.5503 22.75 14.75V9.25C22.75 6.44974 22.75 5.04961 22.205 3.98005C21.7257 3.03924 20.9608 2.27433 20.02 1.79497C18.9504 1.25 17.5503 1.25 14.75 1.25H9.25Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M8.23018 3.28615C8.62441 3.41328 8.84093 3.83592 8.7138 4.23014L8.42638 5.12146C9.4957 4.56484 10.7113 4.24996 12 4.24996C16.2802 4.24996 19.75 7.71975 19.75 12C19.75 16.2802 16.2802 19.75 12 19.75C7.71979 19.75 4.25 16.2802 4.25 12C4.25 11.2318 4.36199 10.4884 4.57104 9.78602C4.68919 9.38902 5.10681 9.16296 5.50382 9.28112C5.90082 9.39927 6.12687 9.81689 6.00872 10.2139C5.84056 10.7789 5.75 11.3782 5.75 12C5.75 15.4517 8.54822 18.25 12 18.25C15.4518 18.25 18.25 15.4517 18.25 12C18.25 8.54818 15.4518 5.74996 12 5.74996C10.251 5.74996 8.67094 6.46738 7.53568 7.6259C7.2922 7.87437 6.90982 7.92279 6.61208 7.74286C6.31435 7.56293 6.17943 7.20188 6.2862 6.87079L7.2862 3.76977C7.41332 3.37555 7.83596 3.15903 8.23018 3.28615ZM9.75 9.49996C9.75 9.08574 10.0858 8.74996 10.5 8.74996H13.5C13.9142 8.74996 14.25 9.08574 14.25 9.49996C14.25 9.91417 13.9142 10.25 13.5 10.25H11.25V11.25H13.5C13.9142 11.25 14.25 11.5857 14.25 12V14.5C14.25 14.9142 13.9142 15.25 13.5 15.25H10.5C10.0858 15.25 9.75 14.9142 9.75 14.5C9.75 14.0857 10.0858 13.75 10.5 13.75H12.75V12.75H10.5C10.0858 12.75 9.75 12.4142 9.75 12V9.49996Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
